import React, { useState, useRef } from "react";
import emailjs from '@emailjs/browser';
import { useNavigate } from "react-router-dom";

function Contact() {
  const navigate = useNavigate();
  const form = useRef();
  const [formData, setFormData] = useState({
    salutation: '',
    name: '',
    email: '',
    contactNumber: '',
    propertyType: '',
    otherPropertyType: '',
    enquiry: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = 'service_18mfqf2';
    const templateID = 'template_phqamrh';
    const publicKey = 'rUCdgM9MIRAjjBqyY';

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then((result) => {
        navigate('/thank-you');
        setFormData({
          salutation: '', name: '', email: '', contactNumber: '', 
          propertyType: '', otherPropertyType: '', enquiry: ''
        });
      }, (error) => {
        console.error('Failed to send email...', error.text);
        alert('Failed to send enquiry. Please try again or email us directly.');
      });
  };

  return (
    <section className="contact">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <div className="contact-info">
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:jianmavrikdesign@gmail.com">jianmavrikdesign@gmail.com</a>
          </p>
          <p>
            <strong>Phone/WhatsApp:</strong>{' '}
            <a href="tel:+60137664766">+6013 7664 766</a>
            <h>/</h>
            <a href="tel:+60122444766">+6012 2444 766</a>
          </p>
          <p>
            <strong>Location:</strong> No.2-1, Jalan Tasik Raja Lumu M U4/M,
            Taman Subang Delima Seksyen U4, 40151 Shah Alam, Selangor.
          </p>
        </div>
      </div>

      {/* Form Section */}
      <div className="enquiry-form">
        <form ref={form} onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Salutation:</label>
            <select
              name="salutation"
              value={formData.salutation}
              onChange={handleChange}
              required
            >
              <option value="">Select Salutation</option>
              <option value="Mr.">Mr.</option>
              <option value="Ms.">Ms.</option>
            </select>
          </div>

          <div className="form-group">
            <label>Name:</label>
            <input 
              type="text" 
              name="name" 
              value={formData.name} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Email:</label>
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Contact Number:</label>
            <input 
              type="tel" 
              name="contactNumber" 
              value={formData.contactNumber} 
              onChange={handleChange} 
              placeholder="e.g. +6012 345 6789"
              required 
            />
          </div>

          <div className="form-group">
            <label>Property Type:</label>
            <select 
              name="propertyType" 
              value={formData.propertyType} 
              onChange={handleChange} 
              required
            >
              <option value="">Select Type</option>
              <option value="Warehouse">Warehouse</option>
              <option value="Shop lot">Shop lot</option>
              <option value="Offices">Offices</option>
              <option value="Condominium">Condominium</option>
              <option value="Semi-D">Semi-D</option>
              <option value="Bungalow">Bungalow</option>
              <option value="others">Others</option>
            </select>
          </div>

          {formData.propertyType === 'others' && (
            <div className="form-group">
              <label>Please specify property type:</label>
              <input 
                type="text" 
                name="otherPropertyType" 
                value={formData.otherPropertyType} 
                onChange={handleChange} 
                required 
              />
            </div>
          )}

          <div className="form-group">
            <label>Enquiry:</label>
            <textarea 
              name="enquiry" 
              value={formData.enquiry} 
              onChange={handleChange} 
              placeholder="e.g. Which area do you cover?"
              required 
            />
          </div>

          <button type="submit" className="submit-btn">Send Enquiry</button>
        </form>
      </div>
    </section>
  );
}

export default Contact;